// extracted by mini-css-extract-plugin
export var resizer = "_ho-0";